var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 1.33398C4.31967 1.33398 1.33301 4.32065 1.33301 8.00065C1.33301 11.6807 4.31967 14.6673 7.99967 14.6673C11.6797 14.6673 14.6663 11.6807 14.6663 8.00065C14.6663 4.32065 11.6797 1.33398 7.99967 1.33398ZM7.33301 13.2873C4.69967 12.9607 2.66634 10.7207 2.66634 8.00065C2.66634 7.58732 2.71967 7.19398 2.80634 6.80732L5.99967 10.0007V10.6673C5.99967 11.4007 6.59967 12.0007 7.33301 12.0007V13.2873ZM10.6663 10.6673C11.2663 10.6673 11.7597 11.054 11.933 11.594C12.7997 10.6473 13.333 9.38732 13.333 8.00065C13.333 5.76732 11.953 3.85398 9.99967 3.06065V3.33398C9.99967 4.06732 9.39967 4.66732 8.66634 4.66732H7.33301V6.00065C7.33301 6.36732 7.03301 6.66732 6.66634 6.66732H5.33301V8.00065H9.33301C9.69967 8.00065 9.99967 8.30065 9.99967 8.66732V10.6673H10.6663Z",
    fill: "#55AA8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Px);
export default __webpack_public_path__ + "static/media/24px.70c52b241632a83f8032a16a0559b961.svg";
export { ForwardRef as ReactComponent };